import { createSlice } from '@reduxjs/toolkit';
import { confirmGeneralInfoStep } from './generalInfoRequest';
import httpErrorHandling from '../../../../utils/httpErrorHandling';
import { OnboardingStepState } from '../../onboardingSlice';

const initialState: OnboardingStepState = {
  error: '',
  inProgress: false,
  doRedirectFurther: false,
  isDone: false,
};
export const generalInfoSlice = createSlice({
  name: 'generalInfo',
  initialState,
  reducers: {
    setGeneralInfoStateDefault: () => {
      return { ...initialState };
    },
    startProcessingGeneralInfo: state => {
      state.inProgress = true;
    },
    submitGeneralInfo: state => {
      state.isDone = true;
      state.inProgress = false;
      state.doRedirectFurther = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(confirmGeneralInfoStep.fulfilled, state => {
      state.error = '';
      state.doRedirectFurther = true;
    });
    builder.addCase(confirmGeneralInfoStep.pending, state => {
      state.error = '';
    });
    builder.addCase(confirmGeneralInfoStep.rejected, (state, action) => {
      const code = httpErrorHandling(action);
      let error;
      switch (code) {
        case 'server.error.generalInfo.shortName.required':
        case 'server.error.generalInfo.shortName.string.empty': {
          error = 'onboarding.general.introduction.notValid';
          break;
        }
        case 'server.error.generalInfo.email.string.empty': {
          error = 'onboarding.general.business.notValid';
          break;
        }
        case 'server.error.generalInfo.businessInfo.email.string.email': {
          error = 'onboarding.general.business.email.notValid';
          break;
        }
        case 'server.error.generalInfo.paymentMethod.array.base': {
          error = 'onboarding.general.business.notValid';
          break;
        }
        case 'server.error.generalInfo.location.required': {
          error = 'onboarding.general.location.notValid';
          break;
        }
        default:
          error = code;
      }
      state.error = error;
    });
  },
});

export const { setGeneralInfoStateDefault, startProcessingGeneralInfo, submitGeneralInfo } = generalInfoSlice.actions;

export default generalInfoSlice.reducer;
